/**
 * Utility functions for Folder View
 */

import type { WorkspaceItemType } from '@loader/shared-types';

import { formatDateTimeShort } from '@/lib/formatters';

/**
 * Get kind label for item type
 */
export function getKindLabel(type: WorkspaceItemType): string {
  switch (type) {
    case 'table':
      return 'Table';
    case 'linked_table':
      return 'Linked Table';
    case 'folder':
      return 'Folder';
    default:
      return 'Item';
  }
}

/**
 * Format date for display (re-export with FolderView-specific handling)
 */
export function formatDate(dateStr?: string): string {
  if (!dateStr) return '—';
  return formatDateTimeShort(dateStr);
}

/**
 * Format bytes to MB for file explorer display
 */
export function formatBytes(bytes: number): string {
  if (bytes <= 0) return '—';
  const mb = bytes / (1024 * 1024);
  // Show 2 decimal places for small files, 1 for larger
  const decimals = mb < 1 ? 2 : 1;
  return `${mb.toFixed(decimals)} MB`;
}
